import React from 'react';
import { Box, Button } from '@mui/material';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import CreditCardAffidavitDialog from './CreditCardAffidavitDialog';
import SignatureStatusDialog from './CarModal/SignatureStatusDialog';

// Create + track the credit card authorization affidavit. Lives next to the
// cards on file on both sides of the business, because the affidavit exists to
// authorize one specific charge — it is a payment action, not a deal document.
//
// `parentType` picks the docType and the table the signature history hangs off:
//   car          -> cc_auth          -> cars/{stock}/signatures
//   serviceOrder -> cc_auth_service  -> orders/{stock}/signatures
export default function CreditCardAffidavitButton({
  parentType = 'car', refId, customer = {}, defaultAmount = 0, vehicleLabel = '', size = 'small',
}) {
  const [open, setOpen] = React.useState(false);
  const [statusOpen, setStatusOpen] = React.useState(false);

  const table = parentType === 'serviceOrder' ? 'orders' : 'cars';
  const type = parentType === 'serviceOrder' ? 'cc_auth_service' : 'cc_auth';

  if (!refId) return null;

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      <Button
        size={size}
        variant="outlined"
        startIcon={<GavelOutlinedIcon />}
        onClick={() => setOpen(true)}
      >
        Card Authorization
      </Button>
      <Button
        size={size}
        variant="text"
        startIcon={<FactCheckOutlinedIcon />}
        onClick={() => setStatusOpen(true)}
      >
        Status
      </Button>

      <CreditCardAffidavitDialog
        open={open}
        onClose={() => setOpen(false)}
        parentType={parentType}
        refId={refId}
        customer={customer}
        defaultAmount={defaultAmount}
        vehicleLabel={vehicleLabel}
      />

      <SignatureStatusDialog
        open={statusOpen}
        onClose={() => setStatusOpen(false)}
        car={{ stock: refId }}
        table={table}
        type={type}
        label="Credit Card Authorization"
      />
    </Box>
  );
}
